import { Link } from 'react-router-dom';
import './Book.css';
import client from './utils/sanity/client.ts';
import { format } from "date-fns"
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import BookImage from './images/Storybook1 (Medium).png';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function Book() {
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const [books, setBooks] = useState([])

  useEffect(() => {
    client.fetch(`*[_type == "book"] {
          title,
          slug,
          chapter,
          body,
          publishedAt,
          mainImage {
            asset -> {
              _id,
              url
            },
            alt,
          }
        } | order(publishedAt desc)`).then((data) => setBooks(data)).catch(console.error)
  }, [])

  return <>
    <div className='books-container'>
      <Helmet>
        <title>Book Page</title>
        <meta name="description" content="Check in here to read Aethel's latest fantasy stories, inspired by fairytales and stories of old." />

        {/* Page-Specific Open Graph Tags */}
        <meta property="og:title" content="Book Page - Aethel Music" />
        <meta property="og:description" content="Check in here to read Aethel's latest fantasy stories, inspired by fairytales and stories of old." />
        <meta property="og:image" content="%PUBLIC_URL%/images/TitleImageMedium.png" />
        <meta property="og:url" content="https://aethel.vercel.app/book" />

        {/* Page-Specific Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Book Page - Aethel Music" />
        <meta name="twitter:description" content="Check in here to read Aethel's latest fantasy stories, inspired by fairytales and stories of old." />
        <meta name="twitter:image" content="%PUBLIC_URL%/images/TitleImageMedium.png" />
      </Helmet>
      <h1>Storybook</h1>
      <section className='book-chapter-container'>

        {books.map((book) => (
          <Link to={`/book/${book.slug.current}`} key={book.slug.current}>
            <article className='book-content-container'>
              <div className='book-img-title-container'>
                <LazyLoadImage src={book.mainImage.asset.url} className='book-main-image' alt={book.title} effect="blur" />

                <h2>{book.title}</h2><h3>{book.chapter}</h3></div>

              <div className="book-titles-container">

                <p className='book'>{`${book.body[0].children[0].text.substring(0, 50)}...`}</p>
                <p className='date'>
                  Published: <span>{format(new Date(book.publishedAt), "dd MMMM yyyy")}</span>
                </p>
                <Link to={`/book/${book.slug.current}`}><button className='read-btn'>
                  Read More</button>
                </Link>
              </div>
            </article>
          </Link>
        ))}
      </section>
    </div>
  </>
}
